<template>
  <div class="card mb-4">
    <div class="card-header pb-0">
      <div class="row">
        <div class="col">
          <h6>Lista de retención</h6>
        </div>
        <div class="col" v-if="isAdmin">
          <button class="btn bg-gradient-danger float-end mb-0" @click="deactivateAll">
            Desactivar todos
          </button>
        </div>
      </div>
    </div>
    <div class="card-body px-4">
      <div class="table-responsive">
        <div class="d-flex justify-content-between">
          <div class="w-25">
            <select name="per_page" id="per_page" v-model="pagination.limit" class="form-control" @click="reloadPaginate(1)">
              <option value="20">20</option>
              <option value="50">50</option>
              <option value="100">100</option>
              <option value="200">200</option>
            </select>
          </div>
          <div class="w-25">
            <input type="text" class="form-control" placeholder="Escribe para buscar por correo o nombre" v-model="pagination.search" @keyup="manualSearch">
          </div>
        </div>
        <table class="table table-bordered table-sm">
          <thead>
          <tr>
            <th class="text-uppercase text-secondary text-xxs font-weight-bolder opacity-7">Nombre</th>
            <th class="text-uppercase text-secondary text-xxs font-weight-bolder opacity-7">Correo electrónico</th>
            <th class="text-uppercase text-secondary text-xxs font-weight-bolder opacity-7">Retención</th>
            <th class="text-uppercase text-secondary text-xxs font-weight-bolder opacity-7 ps-2">País</th>
            <th class="text-uppercase text-secondary text-xxs font-weight-bolder opacity-7">Estado</th>
            <th class="text-uppercase text-secondary text-xxs font-weight-bolder opacity-7">Fecha</th>
            <th class="text-uppercase text-secondary text-xxs font-weight-bolder opacity-7">Opciones</th>
          </tr>
          </thead>
          <tbody>
          <tr v-for="(item, key) in arrayUsers" :key="key">
            <td>
              <p class="text-uppercase text-xs font-weight-bold mb-0">{{item.name}}</p>
            </td>
            <td>
              <p class="text-uppercase text-xs font-weight-bold mb-0">{{item.email}}</p>
            </td>
            <td>
              <p class="text-uppercase text-xs font-weight-bold mb-0">
                <span v-if="item.agent_retention">
                  {{item.agent_retention.name}} - {{item.agent_retention.email}}
                </span>
              </p>
            </td>
            <td>
              <p class="text-xs font-weight-bold mb-0">{{item.country}}</p>
            </td>
            <td>
              <soft-badge :color="item.status ? 'success' : 'secondary'" variant="gradient" size="sm">
                {{item.status ? 'ACTIVO' : 'INACTIVO'}}
              </soft-badge>
            </td>
            <td>
              <p class="text-xs font-weight-bold mb-0">{{$filters.formatDate(item.created_at)}}</p>
            </td>
            <td>
              <button class="btn btn-success btn-sm me-1" @click="vieDetail(item)">Ver</button>
              <button class="btn btn-sm" :class="item.status ? 'btn-secondary' : 'btn-info'" @click="toggleStatus(item)">
                {{item.status ? 'Desactivar' : 'Activar'}}
              </button>
            </td>
          </tr>
          </tbody>
        </table>
        <div class="d-flex justify-content-between">
          <div>
            <p class="text-xs font-weight-bold mb-0">Total de filas: {{pagination.totalRows}}</p>
          </div>
          <div>
            <v-pagination
                v-model="pagination.page"
                :pages="pagination.pages"
                :range-size="1"
                active-color="#DCEDFF"
                @update:modelValue="reloadPaginate"
            />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {get, post} from "@/utils/httpRequest";
import {decrypt} from "@/utils/encrypt";
import SoftBadge from "@/components/SoftBadge.vue";

export default {
  name: "index",
  components: {SoftBadge},
  data: () => ({
    arrayUsers: [],
    pagination: {
      searchTimer: null,
      page: 1,
      pages: 0,
      limit: 20,
      search: '',
      totalRows: 0
    }
  }),
  computed: {
    // El botón "Desactivar todos" es SOLO para administrator. El back igual
    // protege el endpoint con @Roles('administrator'); esto es UX.
    isAdmin(){
      try {
        return decrypt(localStorage.getItem('payment-admin-type')) === 'administrator'
      } catch (e) {
        return false
      }
    }
  },
  mounted() {
    this.getData()
  },
  methods: {
    async deactivateAll(){
      this.$swal({
        html: 'Vas a DESACTIVAR a TODOS los clientes del sistema. Esta acción es masiva. ¿Continuar?',
        icon: 'warning',
        showCancelButton: true,
        confirmButtonText: 'Sí, desactivar todos',
        cancelButtonText: `No`,
      }).then(async (result) => {
        if (result.isConfirmed) {
          try {
            await post('users/deactivate-all-clients', {}, true)
            this.$swal({
              html: 'Todos los clientes fueron desactivados',
              icon: 'success',
              timer: 2500,
              showCancelButton: false,
              showConfirmButton: false,
            });
            this.reloadPaginate(1)
          } catch (e) {
            this.$swal({
              html: 'Ocurrió un error al desactivar los clientes',
              icon: 'error',
              timer: 2500,
              showCancelButton: false,
              showConfirmButton: false,
            });
          }
        }
      })
    },
    reloadPaginate(page){
      this.pagination.page = page
      this.getData()
    },
    manualSearch(){
      clearTimeout(this.pagination.searchTimer);
      this.pagination.searchTimer = setTimeout(() => {
        this.reloadPaginate(1)
      }, 2000);
    },
    async getData(){
      const {data} = await get(`users/find-all-clients?page=${this.pagination.page}&limit=${this.pagination.limit}&search=${this.pagination.search}`,null, true)
      this.arrayUsers = data.docs
      this.pagination.totalRows = data.count
      this.pagination.page = data.page
      this.pagination.pages = data.pages
    },
    async remove(item){
      this.$swal({
        html: '¿Estás seguro?',
        showCancelButton: true,
        confirmButtonText: 'Sí',
        cancelButtonText: `No`,
      }).then(async (result) => {
        if (result.isConfirmed) {
          await post("users/remove", {_id: item._id}, true)
          this.$swal({
            html: 'Procesado con éxito',
            icon: 'success',
            timer: 2000,
            showCancelButton: false,
            showConfirmButton: false,
          });
          this.reloadPaginate(1)
        }
      })
    },
    async toggleStatus(item){
      const newStatus = !item.status
      try {
        await post('users/update', {_id: item._id, status: newStatus}, true)
        const idx = this.arrayUsers.indexOf(item)
        if (idx !== -1) this.arrayUsers[idx] = {...item, status: newStatus}
        this.$swal({
          html: newStatus ? 'Cliente activado' : 'Cliente desactivado',
          icon: 'success',
          timer: 1500,
          showCancelButton: false,
          showConfirmButton: false,
        });
      } catch (e) {
        this.$swal({
          html: 'No se pudo cambiar el estado',
          icon: 'error',
          timer: 2000,
          showCancelButton: false,
          showConfirmButton: false,
        });
      }
    },
    vieDetail(item){
      this.$router.push({name:'users-view', query: {id: item._id}})
    }
  },
}
</script>

<style scoped>

</style>
